import api from "../../utils/apiCliente";

export const getMetodosEnvio = async () => {
  const res = await api.get("/api/checkout/envio/MetodosEnvio");
  return Array.isArray(res.data) ? res.data : [];
};

export const reservarStock = async (items) => {
  const res = await api.post("/api/checkout/reservar", { items });
  return res.data;
};

export const reservaCheckout = async ({ grupo_reserva, telefono, direccion, envio, pago }) => {
  const res = await api.post("/api/checkout/reservar/grupo", {
    grupo_reserva,
    telefono,
    direccion,
    envio,
    pago,
  });
  return res.data;
};

export const crearPaymentIntent = async (grupo_reserva) => {
  const res = await api.post("/api/checkout/stripe/crear-intent", { grupo_reserva });
  return res.data;
};

export const crearOrdenPedido = async (grupo_reserva) => {
  const res = await api.post("/api/checkout/pedidos/pendiente", { grupo_reserva });
  return res.data;
};
